/**
 * @file store actions
 * @author wangzhongpeng
 */

import apis from '../apis/column'
import apisfooter from '../apis/dict'
export default {
  getColumnTreeList (ctx) {
    const { state } = ctx
    const { columnTreeList } = state
    console.log(columnTreeList)
    if (columnTreeList.length > 0) return
    apis.listColumnTree().then(res => {
      ctx.commit('SET_COLUMNTREELIST', res)
    })
  },
  getFooterList (ctx) {
    const { state } = ctx
    const { footerList } = state
    console.log(footerList)
    if (footerList.length > 0) return
    apisfooter.dictList({dictType: 'WebsiteConfig'}).then(res => {
      ctx.commit('SET_FOOTERLIST', res)
    })
  },
  SET_PERMISSION (context, permissionList) {
    // 提交到 mutation 中的 SET_PERMISSION 函数
    context.commit('SET_PERMISSION', permissionList)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js